import { render, staticRenderFns } from "./ResubmitBeneficiary.vue?vue&type=template&id=0b13943b"
import script from "./ResubmitBeneficiary.vue?vue&type=script&lang=js"
export * from "./ResubmitBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports